const getResultsByIndex = (searchResults, indexName)=>{
    if (!searchResults || !indexName) {
        return undefined;
    }
    if (Object.keys(searchResults).indexOf('hits') === -1) {
        return searchResults[indexName];
    } else if (searchResults && Object.keys(searchResults).indexOf('hits') !== -1) {
        return searchResults.index === indexName ? searchResults : undefined;
    }
};

export { getResultsByIndex };
//# sourceMappingURL=get-results-by-index.js.map
